export default [
  {
    path: "/activity-2023/equity-verify",
    component: () =>
      import(
        /* webpackChunkName: 'equity-verify' */ `@/views/common/equity-verify/index.vue`
      ),
  },
  {
    path: "/activity-2023/equity-verify-v2",
    component: () =>
      import(
        /* webpackChunkName: 'equity-verify' */ `@/views/common/equity-verify/index.vue`
      ),
    props: (route) => ({
      isV2: true,
    }),
  },
  {
    path: "/activity-2023/equity-verify/recoreds",
    component: () =>
      import(
        /* webpackChunkName: 'equity-verify' */ `@/views/common/equity-verify/records.vue`
      ),
    meta: {
      title: "抽奖记录",
    },
  },
  {
    path: "/activity-2023/xj-article/:id",
    component: () =>
      import(
        /* webpackChunkName: 'xj-article' */ `@/views/common/xj-article/index.vue`
      ),
    props: (route) => ({ hasNav: route.query.hasNav !== "false" }),
  },
  {
    path: "/activity-2023/helper-center",
    component: () =>
      import(
        /* webpackChunkName: 'helper-center' */ `@/views/common/helper/index.vue`
      ),
  },
  {
    path: "/activity-2023/new-helper-center",
    component: () =>
      import(
        /* webpackChunkName: 'helper-center' */ `@/views/common/new-helper/index.vue`
      ),
  },
  {
    path: "/activity-2023/play-feeling/result/:id",
    component: () =>
      import(
        /* webpackChunkName: 'play-feeling-result' */ `@/views/common/play-feeling/index.vue`
      ),
    props: (route) => {
      const [id] = route.params.id.split("&");
      return { id: Number(id) };
    },
  },
  {
    path: "/activity-2023/activity/list",
    component: () =>
      import(
        /* webpackChunkName: 'activity-list' */ `@/views/common/activity-list/index.vue`
      ),
  },
  {
    path: "/activity-2023/activity/play-list",
    component: () =>
      import(
        /* webpackChunkName: 'activity-play-list' */ `@/views/common/activity-play-list/index.vue`
      ),
  },
  {
    path: "/activity-2023/activity/play-list/detail/:index",
    component: () =>
      import(
        /* webpackChunkName: 'activity-play-list' */ `@/views/common/activity-play-list/detail.vue`
      ),
    props: (route) => ({ index: Number(route.params.index) }),
  },
  {
    path: "/activity-2023/cancel-account",
    component: () =>
      import(
        /* webpackChunkName: 'cancel-account' */ `@/views/common/cancel-account/index.vue`
      ),
  },
  {
    path: "/activity-2023/diamond-chest/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'diamond-chest-index' */ `@/views/common/diamond-gift/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
    }),
  },
  {
    path: "/activity-2023/dress-chest/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'dress-chest-index' */ `@/views/common/dress-chest/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
    }),
  },
  {
    path: "/activity-2023/mystery-man",
    component: () =>
      import(
        /* webpackChunkName: 'mystery-man' */ `@/views/common/mystery-man/index.vue`
      ),
  },
  {
    path: "/activity-2023/expert-auth",
    component: () =>
      import(
        /* webpackChunkName: 'expert-auth' */ `@/views/common/expert-auth/index.vue`
      ),
  },
  {
    path: "/activity-2023/org-relation-charts/:uid",
    component: () =>
      import(
        /* webpackChunkName: 'org-relation-charts' */ `@/views/common/org-relation-charts/index.vue`
      ),
    props: (route) => ({
      uid: Number(route.params.uid),
    }),
    meta: {
      title: "宗门",
    },
  },
  {
    path: "/activity-2023/index/gift/:id",
    component: () =>
      import(
        /* webpackChunkName: 'index-gift' */ `@/views/common/index-gift/index.vue`
      ),
    props: (route) => ({
      id: Number(route.params.id),
    }),
  },
  {
    path: "/activity-2023/wedding-privilege",
    component: () =>
      import(
        /* webpackChunkName: 'wedding-privilege' */ `@/views/common/wedding-privilege/index.vue`
      ),
  },
  {
    path: "/activity-2023/wedding-package/:product_id",
    component: () =>
      import(
        /* webpackChunkName: 'wedding-package' */ `@/views/common/wedding-package/index.vue`
      ),
    props: (route) => ({
      product_id: route.params.product_id,
    }),
  },
  // {
  //   path: "/activity-2023/honor-palace",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'honor-palace' */ `@/views/common/honor-palace/index.vue`
  //     ),
  // },
  {
    path: "/activity-2023/honor-palace",
    component: () =>
      import(
        /* webpackChunkName: 'honor-palace_v2' */ `@/views/common/honor-palace_v2/index.vue`
      ),
  },
  {
    path: "/activity-2023/privilege-set",
    component: () =>
      import(
        /* webpackChunkName: 'privilege-set-index' */ `@/views/common/privilege-set/index.vue`
      ),
  },
  {
    path: "/activity-2023/privilege-set-detail/:id",
    component: () =>
      import(
        /* webpackChunkName: 'privilege-set-detail' */ `@/views/common/privilege-set/set-detail.vue`
      ),
    props: (route) => ({
      id: Number(route.params.id),
    }),
  },
  {
    path: "/activity-2023/total-recharge-2023/:hideFlag",
    component: () =>
      import(
        /* webpackChunkName: 'yd-hell-index' */ "@/views/common/total-recharge-2023/index.vue"
      ),
    props: (route) => ({ hideFlag: route.params.hideFlag }),
  },
  {
    path: "/activity-2023/invite-friend",
    component: () =>
      import(
        /* webpackChunkName: 'invite-friend' */ "@/views/common/invite-friend/index.vue"
      ),
  },
  {
    path: "/activity-2023/be-invited/:id",
    component: () =>
      import(
        /* webpackChunkName: 'invite-friend' */ "@/views/common/invite-friend/be-invited.vue"
      ),
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: "/activity-2023/come-back/friends",
    component: () =>
      import(
        /* webpackChunkName: 'come-back-friends' */ `@/views/common/invite-friend/come-back-friends.vue`
      ),
  },
  {
    path: "/activity-2023/come-back/be-come-back",
    component: () =>
      import(
        /* webpackChunkName: 'be-come-back' */ `@/views/common/invite-friend/be-come-back.vue`
      ),
  },
  {
    path: "/activity-2024/common/point-shop/:activityKey/:shopId/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'yd-hell-index' */ "@/views/common/point-shop/index.vue"
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      activityKey: route.params.activityKey,
      shopId: Number(route.params.shopId),
    }),
  },
  {
    path: "/activity-2024/open-chest-record/:id",
    component: () =>
      import(
        /* webpackChunkName: 'open-chest-record' */ `@/views/common/open-chest-record/index.vue`
      ),
    props: (route) => ({ id: Number(route.params.id) }),
  },
  {
    path: "/activity-2024/chest-reward-rate/:id",
    component: () =>
      import(
        /* webpackChunkName: 'chest-reward-rate' */ `@/views/common/chest-reward-rate/index.vue`
      ),
    props: (route) => ({ id: Number(route.params.id) }),
  },
  {
    path: "/activity-2024/common/beta-test",
    meta: { title: "戏鲸首页改版内测" },
    component: () =>
      import(
        /* webpackChunkName: 'beta-test' */ `@/views/common/beta-test/index.vue`
      ),
  },
  {
    path: "/activity-2024/common/funfair/:entryType/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: 'funfair' */ `@/views/common/funfair/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      firstTab: route.params.firstTab,
    }),
  },
  {
    path: "/activity-2024/jump/:activityKey/:entryType/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: 'jump-index' */ `@/views/common/jump-index/index.vue`
      ),
    props: (route) => ({
      activityKey: route.params.activityKey,
      entryType: route.params.entryType,
      firstTab: route.params.firstTab,
    }),
  },
  // {
  //   path: "/activity-2023/org-relation-charts/:uid",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'org-relation-charts-v2' */ `@/views/common/org-relation-charts-v2/index.vue`
  //     ),
  //   props: (route) => ({ id: Number(route.params.uid) }),
  //   meta: {
  //     title: "宗门",
  //   },
  // },
];
